import { useMemo } from 'react';
import { Stack } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { DateField, DeleteButton, EditButton, List, useDataGrid } from '@refinedev/mui';

const CloudProvidersList = () => {
  const { dataGridProps } = useDataGrid();

  const columns = useMemo<GridColDef[]>(
    () => [
      { field: 'name', headerName: 'Name', width: 200, flex: 2, sortable: false },
      {
        field: 'created',
        headerName: 'Created At',
        renderCell: ({ value }) => <DateField format="LLL" value={value} />,
        flex: 1,
        sortable: false
      },
      {
        field: 'modified',
        headerName: 'Updated At',
        renderCell: ({ value }) => <DateField format="LLL" value={value} />,
        flex: 1,
        sortable: false
      },
      {
        field: 'actions',
        headerName: 'Actions',
        minWidth: 250,
        sortable: false,
        renderCell: params => {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton
                hideText
                recordItemId={params.row.id}
                confirmTitle={'Do you want to delete Cloud Provider: "' + params.row.name + '" ?'}
              />
            </Stack>
          );
        }
      }
    ],
    []
  );

  // Remove sorting until https://github.com/refinedev/refine/issues/7099 is fixed
  const { sortingMode, sortModel, onSortModelChange, ...restDataGridProps } = dataGridProps;

  return (
    <List canCreate>
      <DataGridPro {...restDataGridProps} columns={columns} disableColumnMenu pagination />
    </List>
  );
};

export default CloudProvidersList;
